import axios from 'axios'
import { Button } from '@/atoms/Button'
import { FlexRow } from '@/atoms/FlexContainers/FlexRow'
import { CircleAlertIcon } from '@/atoms/Icons/CircleAlertIcon'
import { CircleCheckOutlineIcon } from '@/atoms/Icons/CircleCheckOutlineIcon'
import { CaptionSM } from '@/atoms/Text'
import { useToast } from '@/molecules/Toast/ToastProvider'
import { useUser } from '@/services/UserService'
import { logger } from '@/utils/logging/logger'
import { useTranslate } from '@/utils/translate/translate-client'

export const VerifyPhoneNumberPill = () => {
  const { t } = useTranslate('account')
  const { user } = useUser()
  const toast = useToast()

  const resendText = async () => {
    if (!user) {
      logger().error('Autobook Reservation Map: No user found')
      return
    }
    const payload = {
      user_uuid: user.id,
    }

    try {
      const response = await axios.post(`${process.env.NEXT_PUBLIC_BFF_API_URL}/autobook/resend-opt-in`, payload)
      logger().info('Autobook resend opt in text successfully', { response })
      toast?.showToast(t('aTextHasBeenSentToYourPhone', 'A text has been sent to confirm your phone number'), {
        icon: <CircleCheckOutlineIcon size={24} color="white" className="-ml-1" />,
      })
    } catch (error) {
      logger().error('Autobook resend confirmation text failed', { error })
      toast.showToast(t('errorResendingText', 'Error resending text'), {
        icon: <CircleAlertIcon size={24} color="white" className="-ml-1" />,
      })
      logger().error('Autobook resend confirmation text failed', { error })
    }
  }

  return (
    <FlexRow className="w-full items-center justify-between gap-2 rounded-xl bg-core-warning-200 px-3 py-2">
      <FlexRow className="items-center gap-1.5">
        <CircleAlertIcon size={16} color="core-warning-800" className="shrink-0" />
        <CaptionSM weight="normal" className="text-core-warning-800">
          Verify phone number to save your seats.
        </CaptionSM>
      </FlexRow>
      <Button variant="plain" onClick={resendText} className="shrink-0 text-core-warning-800 underline">
        <CaptionSM weight="semibold">{t('resendText', 'Resend Text')}</CaptionSM>
      </Button>
    </FlexRow>
  )
}
